import React, { useState } from "react";
import MainBanner from "../../Components/Banner/MainBanner";
import Footer from "../../Components/Footer/Footer";
import Header from "../../Components/Header/Header";
import "../../assets/css/Booking.css";
import { n1, n2, n3, n4 } from "../../constant";
import ProductCard from "../../Components/Cards/ProductCard";
import ReactPaginate from "react-paginate";
import moment from "moment";

function BookingCard(props) {
  let { mainhead, mainnumber, smallhead, details, payDetails } = props;
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(10);

  const handlePageClick = async (data) => {
    setCurrentPage(data?.selected + 1);
  };

  return (
    <>
      <Header />
      <section className="plantingMixing-page">
        <div className="container">
          <div className="row">
            <div className="col-lg-3"></div>
            <div className="col-lg-6">
              <div className="detail_amount_total">
                <div className="main_heading">
                  <h2 className="main_title">{mainhead}</h2>
                  <h4 className="main_number">{mainnumber}</h4>
                  <h4>{details?.membership?.description}</h4>
                </div>
                <div className="card_details">
                  <div className="details_head">{smallhead}</div>
                  <div className="all_booking_details mt-4">
                    <ul>
                      <li>
                        <span>booking time</span>
                        <span>
                          {/* {moment(details?.booking_time).format(
                                              "MM Do YYYY, h:mm a"
                                            )}{" "} */}
                          {details?.booking_time_formatted}
                        </span>
                      </li>
                      <li>
                        <span>booking date</span>
                        <span>{details?.booking_date}</span>
                      </li>
                      {details?.farm_location?.name ? (
                        <li>
                          <span>location</span>
                          <span>{details?.farm_location?.name}</span>
                        </li>
                      ) : null}

                      <li>
                        <span>family membership</span>
                        <span>
                          {details?.is_family_membership == 1 ? "Yes" : "No"}
                        </span>
                      </li>
                      <li>
                        <span>
                          {details?.other_membership?.heading.toLowerCase() ??
                            "extra charge"}{" "}
                          included
                        </span>
                        <span>
                          {details?.other_memberships_included != null || ""
                            ? "Yes"
                            : "No"}
                        </span>
                      </li>
                      <li>
                        <span>payment status</span>
                        <span>
                          {details?.membership?.status == 1
                            ? "Paid"
                            : "Pending"}
                        </span>
                      </li>
                      <li>
                        <span>{details?.PaymentStatus}</span>
                        <span>{payDetails?.PaymentStatus}</span>
                      </li>
                      {/* {details.Campaign && (
												<li>
													<span>{details.Campaign}</span>
													<span>{payDetails?.Campaign}</span>
												</li>
											)} */}
                      <li>
                        <span>{"Total Amount"}</span>
                        <span>${payDetails}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-3"></div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default BookingCard;
